<template>
  <Drawer
    title="Cancel Appointment?"
    back-arrow
    :backdrop="false"
    @hide-drawer="emit('hide-drawer')"
  >
    <div class="px-4">
      <Alert class="mb-4">
        <div>
          This will notify
          <span class="font-bold">{{ appointment.customer.full_name }}</span>
          the appointment has been cancelled.
        </div>
      </Alert>
      <TextArea
        v-model="cancelReason"
        message="Provide a reason*"
        :validation="firstErrorMessage(v$.cancelReason) ? 'error' : ''"
        :helper-text="firstErrorMessage(v$.cancelReason)"
      />
    </div>
    <template #footer>
      <div class="flex gap-4 w-full">
        <Button
          label="Keep Appointment"
          type="Secondary"
          class="w-full"
          @click="emit('hide-drawer')"
        />
        <Button
          label="Cancel Appointment"
          type="Alert"
          class="w-full"
          @click="handleCancel"
        />
      </div>
    </template>
  </Drawer>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useStore } from "vuex";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import Alert from "@/components/Seranova/Alert/Alert.vue";
import Button from "@/components/Seranova/Buttons/Button.vue";
import Drawer from "@/components/Seranova/Drawer/Drawer.vue";
import TextArea from "@/components/Seranova/TextArea/TextArea.vue";
import { AppointmentV2 } from "@/typings/appointment";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

const props = defineProps<{ appointment: AppointmentV2 }>();
const emit = defineEmits(["hide-drawer", "refresh-appointment"]);
const store = useStore();
const cancelReason = ref("");
const v$ = useVuelidate(
  {
    cancelReason: {
      required: helpers.withMessage("Must provide a reason", required)
    }
  },
  {
    cancelReason
  }
);

const handleCancel = async () => {
  const valid = await v$.value.$validate();
  if (!valid) return;
  await store.dispatch("cancelAppointment", {
    id: props.appointment.id,
    reason: cancelReason.value
  });
  window.notify.success("Appointment cancelled");
  emit("refresh-appointment");
};
</script>

<style lang="scss" scoped></style>
